// Modules
import { createBrowserHistory } from 'history';
import { setupListeners } from '@reduxjs/toolkit/dist/query';
import { configureStore, combineReducers } from '@reduxjs/toolkit';
import { routerMiddleware, connectRouter } from 'connected-react-router';
import { useDispatch, useSelector } from 'react-redux';
import { topicApi } from '../services/api';
import { customerServiceContactNumberApi } from '../services/api/customerServiceContactNumberApi';
import { standardOpeningHoursApi } from '../services/api/standardOpeningHoursApi';

import reducers from './reducer/index';
import { customerServiceHolidaysApi } from '../services/api/customerServiceHolidaysApi';

// Setup
const history = createBrowserHistory();

// All reducer

const rootReducer = (reducerHistory) =>
    combineReducers({
        router: connectRouter(reducerHistory),
        ...reducers,
    });

const createStore = (preloadedState = {}) =>
    configureStore({
        reducer: rootReducer(history),
        middleware: (getDefaultMiddleware) =>
            getDefaultMiddleware({
                serializableCheck: false,
            }).concat([
                topicApi.middleware,
                customerServiceContactNumberApi.middleware,
                standardOpeningHoursApi.middleware,
                customerServiceHolidaysApi.middleware,
                routerMiddleware(history),
            ]),
        devTools: process.env.NODE_ENV !== 'production',
        preloadedState,
    });

// Falta crear rootReducer
const store = createStore();

setupListeners(store.dispatch);

const useAppDispatch = () => useDispatch();
const useAppSelector = useSelector;

export { store, history, useAppDispatch, useAppSelector, createStore };
